import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ai_hub_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const onAuth = ["/login", "/signup"].some((p) =>
        window.location.pathname.startsWith(p)
      );
      if (!onAuth) {
        localStorage.removeItem("ai_hub_token");
        localStorage.removeItem("ai_hub_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
